import { preloader } from './modules/removePreloader';
import { header } from "./modules/header";
import { reviewsSliderHandler } from "./modules/reviewsSlider";
import { fancyboxHandler } from './modules/fancyboxHandler';
import { locationListToggle } from './modules/locationListToggle';
import { smoothAnchorScroll } from "./modules/smoothAnchorScroll";
import { inputs } from "./modules/inputs";
import { nouislidersHandler } from './modules/nouisliderHandler';
import { objectsFilterHandler } from './modules/objectsFilter';
import { serviceHoverHandler } from './modules/serviceHover';
import { telMask } from './modules/telMask';

window.addEventListener("load", () => {
  preloader();
  header();
  fancyboxHandler();
  reviewsSliderHandler();
  locationListToggle();
  smoothAnchorScroll();
  inputs();
  nouislidersHandler();
  objectsFilterHandler();
  serviceHoverHandler();
  telMask();
});
